/** Pure, normalized game simulation. No DOM, storage, network or Fusion Siege code. */
export const GOAL = 6;
export const clampX = (x) => Math.max(0.09, Math.min(0.91, Number.isFinite(x) ? x : 0.24));
export function createCircuit() {
  return { state: "ready", player: 0.24, target: 0.24, energy: 0, elapsed: 0, spawn: 0, serial: 0, drops: [], bursts: [], facing: 1 };
}
export function startCircuit(model) {
  if (model.state !== "paused") Object.assign(model, createCircuit());
  model.state = "running";
}
export function pauseCircuit(model) { if (model.state === "running") model.state = "paused"; }
export function stepCircuit(model, delta, direction = 0, catchWidth = 0.065) {
  if (model.state !== "running" || !Number.isFinite(delta)) return;
  const dt = Math.max(0, Math.min(delta, 0.05));
  model.elapsed += dt;
  if (direction) model.target = clampX(model.target + Math.sign(direction) * 0.48 * dt);
  const oldX = model.player;
  model.player += (clampX(model.target) - model.player) * Math.min(1, dt * 16);
  if (Math.abs(model.player - oldX) > 0.0001) model.facing = model.player > oldX ? 1 : -1;
  if (model.energy < GOAL) {
    model.spawn -= dt;
    if (model.spawn <= 0) {
      const positions = [0.24, 0.42, 0.62, 0.36, 0.57, 0.74, 0.3, 0.52];
      model.drops.push({ id: model.serial, x: positions[model.serial++ % positions.length], y: 0.2 });
      model.spawn = 1.15;
    }
    model.drops = model.drops.filter((drop) => {
      const oldY = drop.y;
      drop.y += dt * 0.2;
      if (model.energy < GOAL && oldY <= 0.69 && drop.y >= 0.63 && Math.abs(drop.x - model.player) < catchWidth) {
        model.energy += 1;
        model.bursts.push({ x: drop.x, y: 0.65, life: 0.45 });
        return false;
      }
      return drop.y < 0.79;
    });
    if (model.energy >= GOAL) model.drops = [];
  }
  model.bursts = model.bursts.filter((burst) => { burst.life -= dt; return burst.life > 0; });
  if (model.energy >= GOAL && model.player >= 0.85) model.state = "won";
}
